import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorFallback } from './components/ErrorFallback';
import './styles.css';

createRoot(document.getElementById('root')!).render(<StrictMode><ErrorFallback><App /></ErrorFallback></StrictMode>);
